import { useEffect } from 'react';
import IconFA from '../../../components/icon/icon';
import { useCustomerContext } from '../../../utils/customerContext';

function DbCustomer() {
    const { fetchCustomers, customersTotal } = useCustomerContext();

    useEffect(() => {
        fetchCustomers();
    }, [])
    
    return (
        <div className='dbContainer'>
            <h3 className="dbHeading">
                Kunden: {customersTotal}
            </h3>
            <IconFA iconName='personWalkingArrowLoopLeft' fontSize='24px' color='black' />
        </div>
    );
}

export default DbCustomer;